import { render } from "./ExitButton.vue?vue&type=template&id=fc7ce3a0"
import script from "./ExitButton.vue?vue&type=script&lang=js"
export * from "./ExitButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fc7ce3a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc7ce3a0', script)) {
    api.reload('fc7ce3a0', script)
  }
  
  module.hot.accept("./ExitButton.vue?vue&type=template&id=fc7ce3a0", () => {
    api.rerender('fc7ce3a0', render)
  })

}

script.__file = "src/ui/buttons/ExitButton.vue"

export default script